/**
 * Поиск по нескольким полям записи — один на всё приложение.
 *
 * Несколько слов ищутся каждое по отдельности, в любом порядке и в любых
 * полях: «смекта изжога» находит Смекту с изжогой в заметке. «ё» и «е» не
 * различаются — на телефоне «ё» почти никто не набирает.
 */

function normalize(text: string): string {
  return text.toLowerCase().replaceAll('ё', 'е');
}

export function matchesSearch(
  fields: readonly (string | null | undefined)[],
  query: string,
): boolean {
  const words = normalize(query).split(/\s+/).filter(Boolean);
  if (words.length === 0) return true;

  const haystack = normalize(fields.filter(Boolean).join(' '));
  return words.every((word) => haystack.includes(word));
}

/**
 * Есть ли в полях слово, которое начинается с `prefix`, — для слова, которое
 * ещё допечатывают: «т» находит «тяжкие», но не «стороны».
 */
export function hasWordStartingWith(
  fields: readonly (string | null | undefined)[],
  prefix: string,
): boolean {
  const start = normalize(prefix.trim());
  return normalize(fields.filter(Boolean).join(' '))
    .split(/[^\p{L}\p{N}]+/u)
    .some((word) => word.startsWith(start));
}

/** Одна ли это строка для поиска: без учёта регистра, «ё» и пробелов по краям. */
export function sameText(a: string, b: string): boolean {
  return normalize(a.trim()) === normalize(b.trim());
}

/** Написано ли по-русски: есть ли в тексте кириллица. */
export function hasCyrillic(text: string): boolean {
  return /[а-яё]/i.test(text);
}

/**
 * Подписи без повторов — для списков вроде «где лежит» и «в каком магазине»,
 * собранных из самих записей. Регистр и пробелы по краям второй подписи не
 * заводят: «Машина» и «машина » — одно. Остаётся написание, встреченное
 * первым, — список не переписывается каждой новой записью. По алфавиту.
 */
export function distinctLabels(values: readonly string[]): string[] {
  const labels = new Map<string, string>();
  for (const value of values) {
    const label = value.trim();
    const key = normalize(label);
    if (label && !labels.has(key)) labels.set(key, label);
  }
  return [...labels.values()].sort((a, b) => a.localeCompare(b, 'ru'));
}
